/*
 *
 * App reducer
 *
 */
import { createReducer } from '@reduxjs/toolkit';
import {
  UPDATE_AUTH_TOKEN,
  INITIAL_LOAD_FAILURE,
  AUTH_FAILURE,
  THEME,
  FETCH_TOKEN_DETAILS_REQUEST,
  FETCH_TOKEN_DETAILS_SUCCESS,
  FETCH_TOKEN_DETAILS_FAILURE
} from './constants';
import {
  EKYC_STATUS_FAILURE,
} from '../EkycPage/constants';
import {
  CHANGE_LANGUAGE_REQUEST,
  CHANGE_LANGUAGE,
  LANGUAGE_UPDATE_FAILURE
} from '../LanguageProvider/constants';

export const initialState = {
  loading: null,
  serverError: null,
  token: null,
  linkError: null,
  tokenExpiry: null,
  theme: 'AMAZON',
  authLoading: null,
  userId: null,
  isSales: false
};

const appReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(UPDATE_AUTH_TOKEN, (state, action) => {
      state.token = action.token;
    })
    .addCase(INITIAL_LOAD_FAILURE, (state) => {
      state.linkError = true;
    })
    .addCase(AUTH_FAILURE, (state) => {
      state.tokenExpiry = true;
      state.loading = false;
    })
    .addCase(EKYC_STATUS_FAILURE, (state) => {
      state.loading = false;
      state.serverError = true;
    })
    .addCase(THEME, (state, action) => {
      state.theme = action.theme;
    })
    .addCase(CHANGE_LANGUAGE_REQUEST, (state) => {
      state.loading = true;
    })
    .addCase(CHANGE_LANGUAGE, (state) => {
      state.loading = false;
    })
    .addCase(FETCH_TOKEN_DETAILS_REQUEST, (state) => {
      state.authLoading = true;
    })
    .addCase(FETCH_TOKEN_DETAILS_SUCCESS, (state, action) => {
      state.authLoading = false;
      state.userId = action.response.user_id;
      state.isSales = !!(action.response.roles.split(',') || []).find(role => role === 'sales');
    })
    .addCase(FETCH_TOKEN_DETAILS_FAILURE, (state) => {
      state.serverError = true;
      state.authLoading = false;
    })
    .addCase(LANGUAGE_UPDATE_FAILURE, (state) => {
      state.serverError = true;
      state.loading = false;
    });
});

export default appReducer;
